<template>
  <div class="groupsPrdtListing">
    <section class="detail_content">
      <ul class="list_panel" v-if="availableCutpriceList.length > 0">
        <router-link
          tag="li"
          v-for="(availCutPrice,index) in availableCutpriceList"
          :key="index"
          :to="`/detail/${ availCutPrice.saleReferenceID}?source=CUT_PRICE`"
        >
          <span class="img_wrapper">
            <img :src="availCutPrice.displayImage" alt="product-image" />
          </span>
          <p class="userdetail">
            <span class="name">{{availCutPrice.itemName}}</span>
            <span class="price">₹​ {{availCutPrice.pricingDTO.sellingPrice}}</span>
            <span class="location" v-if="availCutPrice.pricingDTO.totalPaidAmount > 0">{{$t('getThisItem' , {value:availCutPrice.pricingDTO.totalPaidAmount})}}</span>
            <span class="location" v-else>{{$t('getThisFree' , {value:'FREE'})}}</span>
          </p>
          <span class="cut_amount">
            <i class="material-icons">arrow_forward_ios</i>
          </span>
        </router-link>
      </ul>
      <NoDataFound v-if="noData == true && this.availableCutpriceList && this.availableCutpriceList == 0" class="no_record" />
      <infinite-loading @infinite="cutPriceAvailProducts" spinner="circles" :class="{'visibilityHidden': noData == true}">
        <template slot="no-results">{{$t('noMoreRecord')}}</template>
      </infinite-loading>

      <div class="loader" v-if="loading">
        <img src="../../assets/images/loader.gif" alt="loader" />
      </div>
    </section>
  </div>
</template>

<script>
import NoDataFound from "../../components/Common/NoDataFound"
export default {
  name: "CutThePriceProductListing",
  components: {
    NoDataFound
  },
  data() {
    return {
      availableCutpriceList: [],
      availableCutPriceIndex: 0,
      loading: false,
      noData: false
    };
  },
  methods: {
    cutPriceAvailProducts($state) {
      this.loading = true;
      this.$store
        .dispatch({
          type: "getProductType",
          payload: "CUT_PRICE?page=" + this.availableCutPriceIndex
        })
        .then(data => {
          this.loading = false;

          if (data.data.merchandiseCutPriceDTOs.length > 0) {
            this.availableCutpriceList.push(
              ...data.data.merchandiseCutPriceDTOs
            );
            this.$store.commit("saveAvailProductCutPrice", {
              availCutPriceListData: this.availableCutpriceList,
              availCutPriceIndex: this.availableCutPriceIndex + 1
            });
            this.availableCutPriceIndex += 1;
            $state && $state.loaded();
          } else {
            this.noData = true
            $state && $state.complete();
          }
        })
        .catch(err => {
          this.loading = false;
          console.log(err);
        });
    }
  },
  mounted() {
    this.loading = true;
  }
};
</script>
    <style scoped>
    .list_panel li .userdetail span.price{
  font-weight: normal;
}
    .visibilityHidden{
      visibility: hidden;
    }
    </style>
